import { useSelector } from "react-redux";
import ProductInventoryPriceRepository from "src/repository/ProductInventoryPriceRepository";
import Constants from "src/helper/Constants";
import store from "src/storeWire";
import System from "src/helper/system";

export function useProductInventoryPriceStore() {
    const inventoryList = useSelector((state) => state.entities.model_ProductInventoryPrice.inventory_list)
    const pricing_list = useSelector((state) => state.entities.model_ProductInventoryPrice.pricing_list)

    let data = {
        inventoryList,
        pricing_list
    };

    let fetch = {
        fetch_product_inventory_list: async (params, source = "") => {
            return await new ProductInventoryPriceRepository().getInventory(params, source)
        },
        get_inventory_by_id: (id) => {
            return inventoryList && inventoryList[id] ? inventoryList[id] : { inventoryQty: 0, factoryStock: 0 };
        },
        get_inventory_by_distributor: (product, inventory) => {
            return new ProductInventoryPriceRepository().getInventoryByDistributor(product, inventory)
        },
        get_inventory_lead_time: (FactoryLeadTime, constrainPartFlag) => {
            let status = ""
            Constants.FactoryLeadTime.includes(FactoryLeadTime)|| constrainPartFlag ?
                status = "Constrained part. Lead time unavailable" :
                status = System.daysToWeeksAndDays(FactoryLeadTime)
            return status
        },
        get_inventory_params: (product) => {
            return new ProductInventoryPriceRepository().getInventoryParams(product)
        },
        get_pricing_by_id: (params) => {
            let Id = params.uniqueId ? params.uniqueId : params.ItemNumber;
            let state = store.getState();
            let price = state.entities.model_ProductInventoryPrice.pricing_list
            return price[Id]?.pricing ? price[Id].pricing : []
        },
        get_current_price_by_quantity: (single_product_pricing_list, QuantityToCart, first_tir_price) => {
            return new ProductInventoryPriceRepository().getCurrentPriceByQuantityAndPriceArray(single_product_pricing_list, QuantityToCart, first_tir_price);

        },
        get_exchange_rate: (params) => {
            return new ProductInventoryPriceRepository().getExchangeRate(params)
        },

    };
    let set = {};

    return [data, fetch, set]
}